/* global document */
import '..';
import Nette from 'nette-forms';
import $ from 'jquery';


// Datepicker and representative container
$('#frm-extraForm-birthDate').datepicker().on('changeDate', function birthDateChagedDate() {
	Nette.toggleForm(this.form, this);
});

$(document).on('click', '.btn-start', () => {
	let valid = true;
	$('#checkbox-container').find('.nette-error').remove();

	// Terms and Conditions checked
	if ($('input[name="toc"]:checked').length > 0) {
		$('#toc-error').attr('hidden', '');
	} else {
		valid = false;
		$('#toc-error').removeAttr('hidden');
	}

	// Agency consent checked
	if ($('input[name="agencyConsent"]:checked').length > 0) {
		$('#agency-consent-error').attr('hidden', '');
	} else {
		valid = false;
		$('#agency-consent-error').removeAttr('hidden');
	}

	if (valid) {
		$('#language-switch').attr('hidden', '');
		$('#intro-container').attr('hidden', '');
		$('#checkbox-container').attr('hidden', '');
		$('#questionnaire-container').removeAttr('hidden');
		$('#addManuallyTab').removeAttr('novisible');
	}
});

$(document).on('click', '.js-changeTab', function changeTab() {
	const id = $(this).data('currentTab');
	const back = $(this).data('back');
	if (back !== true) {
		$(`#${id}`)
			.next()
			.trigger('click');
	} else {
		$(`#${id}`)
			.prev()
			.trigger('click');
	}
	$('body').animate({ scrollTop: 0 }, 'fast');
});
$(document).on('click', '.js-morePhotos', function showMorePhotos() {
	const id = $(this).data('target');
	$(`#${id}`).removeAttr('hidden');
	$(this).attr('hidden', '');
});
$(document).on('scroll', () => {
	const dateInput = $('#frm-extraForm-birthDate');
	if (dateInput.data('datepicker').picker.is(':visible')) {
		dateInput.datepicker('place');
	}
});

$(document).on('keydown', '.login-input', (e) => {
	const key = e.charCode || e.keyCode || 0;
	if (key === 13) {
		e.preventDefault();
		$('.login-submit').click();
	}
});



// WEBPACK FOOTER //
// ./frontend/entries/public.js